import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

import { getToken } from "@/utils/tokenStorage";

import { listarTaxas, mensagemDeErro } from "../api";

const API = "/api";
const cfg = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });
const ativo = (v) => (typeof v === "number" ? v === 1 : typeof v === "string" ? v === "true" || v === "1" : Boolean(v));

/** Lista de formas + taxas, e as ações rápidas da lista (mesma lógica do popup antigo). */
export default function useFormas() {
  const [formas, setFormas] = useState([]);
  const [taxas, setTaxas] = useState({ formas: [], canais: [] });
  const [carregando, setCarregando] = useState(true);

  const carregar = useCallback(async () => {
    setCarregando(true);
    try {
      const [r, t] = await Promise.all([axios.get(`${API}/payment-methods`, cfg()), listarTaxas().catch(() => ({ formas: [], canais: [] }))]);
      setFormas((r.data || []).map((pm) => ({ ...pm, is_active: ativo(pm.is_active) })));
      setTaxas(t);
    } catch (e) {
      if ([404, 500].includes(e.response?.status)) {
        await axios.post(`${API}/payment-methods/ensure-table`, {}, cfg()).catch(() => {});
      }
      toast.error("Erro ao carregar formas de pagamento");
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const executar = async (fn, sucesso, erro) => {
    try { await fn(); if (sucesso) toast.success(sucesso); await carregar(); return true; } catch (e) { toast.error(mensagemDeErro(e, erro)); return false; }
  };

  const inicializar = () => executar(() => axios.post(`${API}/payment-methods/initialize`, {}, cfg()), "Formas de pagamento criadas", "Erro ao inicializar");
  const excluir = (pm) => executar(() => axios.delete(`${API}/payment-methods/${pm.id}`, cfg()), "Forma de pagamento excluída", "Erro ao excluir");
  const alternarModulo = (pm, mod) => executar(() => axios.put(`${API}/payment-methods/${pm.id}`, { [`visible_${mod}`]: !pm[`visible_${mod}`] }, cfg()), null, "Erro ao atualizar visibilidade");
  const alternarAtiva = (pm) => executar(() => axios.put(`${API}/payment-methods/${pm.id}`, { is_active: !pm.is_active }, cfg()),
    pm.is_active ? "Forma desativada" : "Forma reativada", "Erro ao atualizar status");

  const mover = (indice, delta) => {
    const alvo = indice + delta;
    if (alvo < 0 || alvo >= formas.length) return null;
    const nova = [...formas];
    [nova[indice], nova[alvo]] = [nova[alvo], nova[indice]];
    const ordem = nova.map((pm, i) => ({ id: pm.id, display_order: i }));
    return executar(() => axios.put(`${API}/payment-methods/order`, { payment_method_orders: ordem }, cfg()), null, "Erro ao atualizar ordem");
  };

  const taxaDe = (code) => taxas.formas.find((t) => t.chave === code) || null;
  return { formas, taxas, carregando, inicializar, excluir, alternarModulo, alternarAtiva, mover, taxaDe };
}
